import React from "react";
import { Switch } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function SwitchField({ label, name, ...rest }) {
  return (
    <div className="mb-3">
      <Field name={name}>
        {({ field, form }) => (
          <div className="flex items-center gap-2">
            <Switch
              id={name}
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              {...rest}
              checked={!!field.value}
              onChange={(checked) => {
                form.setFieldValue(name, checked);
                form.setFieldTouched(name, true);
              }}
            />
            <label htmlFor={name}>{label}</label>
          </div>
        )}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default SwitchField;
